// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// export const activeNotification = createAsyncThunk(
//   "notification/get",
//   async ({ data }) => {
//     try {
//       return data;
//     } catch (err) {
//       throw err;
//     }
//   }
// );

// export const activeLoading = createAsyncThunk("loading", async (data) => {
//   try {
//     return data;
//   } catch (err) {
//     throw err;
//   }
// });

// const notificationSlice = createSlice({
//   name: "notification",
//   initialState: {
//     loading: false,
//     error: null,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(activeNotification.pending, (state) => {})
//       .addCase(activeNotification.fulfilled, (state, action) => {
//         state.key = action.payload.message.key;
//         state.data = action.payload.message.data;
//         state.notification = action.payload.message.text;
//       })
//       .addCase(activeNotification.rejected, (state, action) => {});
//     builder
//       .addCase(activeLoading.pending, (state) => {})
//       .addCase(activeLoading.fulfilled, (state, action) => {
//         state.loading = action.payload;
//       })
//       .addCase(activeLoading.rejected, (state, action) => {});
//   },
// });

// export default notificationSlice.reducer;

import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    loading: false,
    error: null,
    latest: null,
    list: [],
  },
  reducers: {
    activeNotification: (state, action) => {
      state.latest = action.payload;
      state.list.unshift(action.payload);
    },
    activeLoading: (state, action) => {
      state.loading = action.payload;
    },
    activeType2Loading: (state, action) => {
      state.blockEverything = action.payload;
    },
    clearNotifications: (state) => {
      state.list = [];
      state.latest = null;
    },
  },
});

export const {
  activeNotification,
  activeLoading,
  clearNotifications,
  activeType2Loading,
} = notificationSlice.actions;

export default notificationSlice.reducer;
